
import React, { useEffect } from 'react';
import Header from '../components/Header';
import HeroCarousel from '../components/HeroCarousel';
import LocationCard from '../components/LocationCard';
import ComboCard from '../components/ComboCard';
import WholesaleForm from '../components/WholesaleForm';
// import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import { locations, combos } from '../data/mockData';
import { Button } from '../components/ui/button';
import { ChevronRight } from 'lucide-react';
import { motion } from "framer-motion";
import { useNavigate, useLocation } from 'react-router-dom';

// Local Images
import FamosinhoImg from '../images/Famosinho.jpg';
import BannerCardapio from '../images/Banner_Cardápio.jpg';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if we need to scroll to stores (either via /menu route or hash)
    if (location.pathname === '/menu' || location.hash === '#lojas') {
        setTimeout(() => {
            const section = document.getElementById('lojas');
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100); // Slight delay to ensure DOM is ready
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 pt-[164px]"> 
      <Header />
      
      <main>
        {/* Hero Section */}
        <HeroCarousel />

        {/* Value Prop Section */}
        <section className="relative py-28 text-center overflow-hidden">
             {/* Background Image for Value Prop */}
            <div className="absolute inset-0 z-0">
                <img 
                    src={FamosinhoImg} 
                    alt="Background" 
                    className="w-full h-full object-cover opacity-20"
                />
            </div>
            
            <div className="container mx-auto px-4 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="text-4xl md:text-6xl font-black text-[#E63312] uppercase tracking-tighter mb-8 leading-none">
                        O Famoso é o<br/>Sucesso da Sua Festa
                    </h1>
                    <div className="w-24 h-1.5 bg-[#E63312] mx-auto mb-8 rounded-full"></div>
                    <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto font-light leading-relaxed">
                        Do salgado ao doce, da coxinha ao mini-churros, nenhuma festa é a mesma sem <span className="font-bold text-[#E63312]">O Famoso</span>.
                    </p>
                </motion.div>
            </div>
        </section>

        {/* Locations Grid */}
        <section id="lojas" className="py-20" style={{ backgroundColor: 'rgb(255, 248, 227)' }}>
            <div className="container mx-auto px-4">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-black uppercase text-[#E63312] tracking-wide">ENCONTRE UMA LOJA PRÓXIMA</h2>
                </motion.div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {locations.map((location, index) => (
                        <LocationCard key={location.id} location={location} index={index} />
                    ))}
                </div>
            </div>
        </section>

        {/* Menu CTA Section */}
        <section id="cardapio" className="relative py-40 bg-fixed bg-cover bg-center group" style={{ backgroundImage: `url(${BannerCardapio})` }}>
            <div className="absolute inset-0 bg-black/50 transition-colors duration-500 group-hover:bg-black/60" />
            <div className="container mx-auto px-4 relative z-10 text-center text-white">
                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-5xl md:text-7xl font-black uppercase mb-10 tracking-wide drop-shadow-2xl leading-none">
                        Veja Nosso<br/>Cardápio de Delícias
                    </h2>
                    <Button 
                        onClick={() => navigate('/cardapio')}
                        className="bg-[#E63312] hover:bg-[#b01e1e] text-white text-xl px-16 py-8 rounded-full shadow-2xl transition-transform hover:scale-110 hover:shadow-red-900/50 uppercase font-bold tracking-widest border-4 border-transparent hover:border-[#FFC300]"
                    >
                        Acessar Cardápio <ChevronRight className="ml-2 w-6 h-6" />
                    </Button>
                </motion.div>
            </div>
        </section>

        {/* Gallery Section Removed */}

        {/* Combos Section */}
        <section className="py-28 container mx-auto px-4 overflow-hidden">
             <motion.div 
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-20"
             >
                <span className="text-[#E63312] font-bold tracking-[0.2em] uppercase text-sm md:text-base mb-4 block">Ofertas Imperdíveis</span>
                <h2 className="text-4xl md:text-5xl font-black text-gray-900 uppercase">Promoções Especiais</h2>
             </motion.div>
             
             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                {combos.map((combo, index) => (
                    <motion.div
                        key={combo.id}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: index * 0.15, duration: 0.6 }}
                        className="h-full"
                    >
                        <ComboCard combo={combo} />
                    </motion.div>
                ))}
             </div>
        </section>

        {/* Wholesale Form Section */}
        <WholesaleForm />
      </main>

      <Footer />
    </div>
  );
};

export default Home;
